(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bf-script"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const root = document.documentElement;
  const $ = (s, p = document) => p.querySelector(s);
  const $$ = (s, p = document) => [...p.querySelectorAll(s)];
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let motion = !reduced.matches;
  try { motion = motion && localStorage.getItem('byteful-motion') !== 'off'; } catch (_) {}
  root.classList.add('bf-js');
  const animate = (el, frames, options = {}) => {
    if (!el || !motion) return;
    return el.animate(frames, {duration: 850, easing: 'cubic-bezier(.16,1,.3,1)', ...options});
  };
  const seen = new IntersectionObserver(entries => entries.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('bf-seen'); seen.unobserve(e.target); }
  }), {threshold: .08, rootMargin: '0px 0px -20px 0px'});
  let frameId = 0, artVisible = false, elapsed = 0, last = 0, art, visual, img, canvas, gl, program, uniforms;
  const mouse = {x:.5,y:.5,cx:.5,cy:.5,energy:0};
  function updateMotion(value, save = false) {
    motion = value;
    root.classList.toggle('bf-motion-off', !motion);
    $$('.bf-motion-toggle').forEach(b => {
      b.setAttribute('aria-pressed', String(!motion));
      b.setAttribute('aria-label', motion ? b.dataset.stop : b.dataset.start);
      $('.bf-motion-label',b).textContent = motion ? b.dataset.on : b.dataset.off;
    });
    if (!motion) {
      document.getAnimations().filter(a=>a.effect?.target?.closest('.bf-hero,.bf-dialog') && Number.isFinite(a.effect.getComputedTiming().endTime)).forEach(a=>a.finish());
      if (visual) visual.style.transform = '';
      if (canvas) canvas.style.opacity = '0';
      cancelAnimationFrame(frameId); frameId = 0;
    } else { if(gl && canvas) canvas.style.opacity = '1'; start(); }
    if(save) try { localStorage.setItem('byteful-motion', motion ? 'on' : 'off'); } catch (_) {}
  }
  function scrollEffects() {
    const top = window.scrollY;
    const range = document.documentElement.scrollHeight-innerHeight;
    const progress = $('.bf-read-progress');
    if(progress) progress.style.transform = `scaleX(${range > 0 ? top/range : 0})`;
    if(motion && art && artVisible && innerWidth > 760) {
      const p = Math.min(1,top/(art.closest('section').offsetHeight||800));
      visual.style.transform = `translateY(${p*65}px) rotate(${-p*7}deg)`;
    }
    $$('.bf-manifesto>span').forEach(el=>{
      const ratio = Math.max(0,Math.min(1,(innerHeight*.86-el.getBoundingClientRect().top)/(innerHeight*.35)));
      el.style.color = motion ? `rgb(${Math.round(135-ratio*125)},${Math.round(135-ratio*125)},${Math.round(129-ratio*119)})` : '';
    });
  }
  let queued = false;
  addEventListener('scroll',()=>{if(!queued){queued=true;requestAnimationFrame(()=>{scrollEffects();queued=false;});}},{passive:true});
  function closeMenu() {
    const dialog = $('#bf-menu');
    if(!dialog?.open) return;
    dialog.close();
    document.body.classList.remove('bf-locked');
    $('.bf-menu-toggle')?.setAttribute('aria-expanded','false');
  }
  function initialize(scope = document) {
    $$('.bf-reveal',scope).forEach(el=>seen.observe(el));
    $$('[data-bf-menu]',scope).forEach(b=>{
      if(b.dataset.bound) return; b.dataset.bound='1';
      b.addEventListener('click',()=>{
        const dialog = $('#bf-menu'); if(!dialog) return;
        dialog.showModal(); document.body.classList.add('bf-locked');
        b.setAttribute('aria-expanded','true');
        animate(dialog,[{clipPath:'inset(0 0 100% 0)'},{clipPath:'inset(0 0 0% 0)'}],{duration:700});
        $$('.bf-menu-nav strong',dialog).forEach((el,i)=>animate(el,[{opacity:0,transform:'translateY(40px)'},{opacity:1,transform:'none'}],{delay:150+i*55,fill:'backwards'}));
      });
    });
    $$('[data-bf-close]',scope).forEach(b=>b.addEventListener('click',closeMenu));
    $('#bf-menu')?.addEventListener('cancel',e=>{e.preventDefault();closeMenu();});
    $$('.bf-motion-toggle',scope).forEach(b=>b.addEventListener('click',()=>updateMotion(!motion,true)));
    $$('.bf-service,.bf-faq-item',scope).forEach(item=>{
      if(item.dataset.bound) return; item.dataset.bound='1';
      item.addEventListener('toggle',()=>{
        if(item.open) animate(item.lastElementChild,[{opacity:0,transform:'translateY(10px)'},{opacity:1,transform:'none'}],{duration:550});
      });
    });
    const select = $('[name="contact[Hizmet]"]',scope);
    if(select) { const requested = new URLSearchParams(location.search).get('hizmet'); if(requested && [...select.options].some(o=>o.value===requested)) select.value=requested; }
    const form = $('.bf-form',scope);
    if(form && root.dataset.preview==='true') form.addEventListener('submit',e=>{
      e.preventDefault(); if(!form.reportValidity())return;
      $('.bf-form-status',form).textContent='Bu yerel ön izlemede mesaj gönderilmez. Shopify mağazasında form, mağazanın e-posta sistemini kullanır.';
    });
    updateMotion(motion);
    scrollEffects();
  }
  function initArt() {
    art=$('.bf-hero-art'); if(!art)return;
    visual=$('.bf-art-visual',art); img=$('img',visual); canvas=$('canvas',visual);
    new IntersectionObserver(es=>{artVisible=es[0].isIntersecting;if(artVisible)start();},{threshold:0}).observe(art);
    art.addEventListener('pointermove',e=>{const r=art.getBoundingClientRect();mouse.x=(e.clientX-r.left)/r.width;mouse.y=1-(e.clientY-r.top)/r.height;},{passive:true});
    art.addEventListener('pointerleave',()=>{mouse.x=mouse.y=.5;});
    art.addEventListener('click',()=>{mouse.energy=3;});
    art.addEventListener('keydown',e=>{
      if(!e.key.startsWith('Arrow')||!motion)return;e.preventDefault();
      mouse.x=Math.max(0,Math.min(1,mouse.x+(e.key==='ArrowRight'?.2:e.key==='ArrowLeft'?-.2:0)));
      mouse.y=Math.max(0,Math.min(1,mouse.y+(e.key==='ArrowUp'?.2:e.key==='ArrowDown'?-.2:0)));mouse.energy=1;
    });
    function create() {
      if(!img.naturalWidth)return;
      try {
        gl=canvas.getContext('webgl',{alpha:false,antialias:false,depth:false,powerPreference:'low-power'});
        if(!gl)return;
        const vs='attribute vec2 p;varying vec2 uv;void main(){uv=p*.5+.5;gl_Position=vec4(p,0.,1.);}';
        const fs=`precision mediump float;uniform sampler2D image;uniform vec2 resolution;uniform vec2 imageSize;uniform vec2 pointer;uniform float time;uniform float energy;varying vec2 uv;void main(){vec3 bg=vec3(10./255.);float a=resolution.x/resolution.y;float b=imageSize.x/imageSize.y;vec2 c=vec2(max(a/b,1.),max(b/a,1.));vec2 v=(uv-.5)*c;float ang=sin(time*.26)*.04+(pointer.x-.5)*.1;v=mat2(cos(ang),-sin(ang),sin(ang),cos(ang))*v;v-=vec2(pointer.x-.5,pointer.y-.5)*.04;v.y+=sin(time*.42)*.014;v+=.5;vec2 delta=v-((pointer-.5)*c+.5);float d=length(delta);v+=delta/max(d,.001)*sin(d*23.-time*2.)*exp(-d*5.)*.009*(.6+energy);if(v.x<0.||v.x>1.||v.y<0.||v.y>1.){gl_FragColor=vec4(bg,1.);return;}vec3 color=texture2D(image,v).rgb;float edge=smoothstep(0.,.1,v.x)*smoothstep(0.,.1,1.-v.x)*smoothstep(0.,.08,v.y)*smoothstep(0.,.08,1.-v.y);gl_FragColor=vec4(mix(bg,color,edge),1.);}`;
        function compile(type,source){const s=gl.createShader(type);gl.shaderSource(s,source);gl.compileShader(s);if(!gl.getShaderParameter(s,gl.COMPILE_STATUS))throw Error('shader');return s;}
        program=gl.createProgram();gl.attachShader(program,compile(gl.VERTEX_SHADER,vs));gl.attachShader(program,compile(gl.FRAGMENT_SHADER,fs));gl.linkProgram(program);if(!gl.getProgramParameter(program,gl.LINK_STATUS))throw Error('program');gl.useProgram(program);
        const buffer=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,buffer);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,1,-1,-1,1,-1,1,1,-1,1,1]),gl.STATIC_DRAW);const p=gl.getAttribLocation(program,'p');gl.enableVertexAttribArray(p);gl.vertexAttribPointer(p,2,gl.FLOAT,false,0,0);
        gl.bindTexture(gl.TEXTURE_2D,gl.createTexture());gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,gl.LINEAR);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,gl.LINEAR);gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,true);gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,img);
        uniforms={};['resolution','imageSize','pointer','time','energy'].forEach(k=>uniforms[k]=gl.getUniformLocation(program,k));gl.uniform2f(uniforms.imageSize,img.naturalWidth,img.naturalHeight);resize();if(motion)canvas.style.opacity='1';start();
      } catch(_){gl=null;canvas.style.opacity='0';start();}
    }
    img.addEventListener('load',create,{once:true}); if(img.complete)create();
    canvas.addEventListener('webglcontextlost',e=>{e.preventDefault();gl=null;canvas.style.opacity='0';});
    canvas.addEventListener('webglcontextrestored',create);
  }
  function resize(){if(!gl||!canvas)return;const dpr=Math.min(devicePixelRatio||1,innerWidth<760?1.25:1.5);canvas.width=Math.max(1,Math.round(visual.clientWidth*dpr));canvas.height=Math.max(1,Math.round(visual.clientHeight*dpr));gl.viewport(0,0,canvas.width,canvas.height);}
  function frame(now){frameId=0;if(!motion||document.hidden||!artVisible){last=0;return;}const dt=Math.min((now-(last||now))/1000,.05);elapsed+=dt;last=now;mouse.cx+=(mouse.x-mouse.cx)*(1-Math.exp(-dt*5));mouse.cy+=(mouse.y-mouse.cy)*(1-Math.exp(-dt*5));mouse.energy=Math.max(0,mouse.energy-dt*.8);if(gl){gl.uniform2f(uniforms.resolution,canvas.width,canvas.height);gl.uniform2f(uniforms.pointer,mouse.cx,mouse.cy);gl.uniform1f(uniforms.time,elapsed);gl.uniform1f(uniforms.energy,mouse.energy);gl.drawArrays(gl.TRIANGLES,0,6);}else if(img){img.style.transform=`rotate(${Math.sin(elapsed*.3)}deg) translateY(${Math.sin(elapsed*.45)*7}px)`;}start();}
  function start(){if(!frameId&&motion&&!document.hidden&&artVisible)frameId=requestAnimationFrame(frame);}
  addEventListener('resize',()=>{resize();scrollEffects();},{passive:true});
  document.addEventListener('visibilitychange',()=>{if(document.hidden){cancelAnimationFrame(frameId);frameId=0;last=0;}else start();});
  reduced.addEventListener('change',()=>updateMotion(!reduced.matches));
  document.addEventListener('shopify:section:load',e=>initialize(e.target));
  document.addEventListener('shopify:section:unload',closeMenu);
  initialize();initArt();
  Promise.race([document.fonts.ready,new Promise(r=>setTimeout(r,800))]).then(()=>{
    $$('.bf-mask>span').forEach((el,i)=>animate(el,[{transform:'translateY(112%) rotate(3deg)'},{transform:'none'}],{duration:1250,delay:100+i*120,fill:'backwards'}));
    animate($('.bf-hero-art'),[{opacity:0,transform:'scale(1.09) rotate(6deg)'},{opacity:1,transform:'none'}],{duration:1500});
    animate($('.bf-header'),[{opacity:0,transform:'translateY(-15px)'},{opacity:1,transform:'none'}],{duration:700});
    animate($('.bf-hero-lower'),[{opacity:0,transform:'translateY(20px)'},{opacity:1,transform:'none'}],{delay:500,fill:'backwards'});
  });
})();
  } catch(e) { console.error(e); }
})();

})();
